import { render, staticRenderFns } from "./onebox-dataetax.vue?vue&type=template&id=676bf7fa&"
import script from "./onebox-dataetax.vue?vue&type=script&lang=js&"
export * from "./onebox-dataetax.vue?vue&type=script&lang=js&"
import style0 from "./onebox-dataetax.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports